<mat-form-field id="selectGEN-mat-form" [formGroup]="group" class="custom-form-field">
  <mat-label>{{ field.displayName }}</mat-label>
  <mat-select [formControlName]="field.name" [id]="field.name" [(ngModel)]="modeSelect">
    <mat-option
      id="selectGEN-mat-form-option"
      *ngFor="let item of field.options"
      [value]="item.value"
      (click)="onchange(item.value)"
      >{{ item.value }}</mat-option
    >
  </mat-select>
  <ng-container id="selectGEN-ng-container" *ngFor="let validation of field.validations" ngProjectAs="mat-error">
    <mat-error id="selectGEN-mat-form-error{{ field.name }}" *ngIf="group.get(field.name).hasError(validation.name)">{{
      validation.message
    }}</mat-error>
  </ng-container>
</mat-form-field>
